export default __webpack_public_path__ + "static/media/internationalBg@2x.0945ea33.png";